import {
  get,
  formatUrl,
  deleteMethod,
  patch,
  post
} from '../../../utils/request'
import {
  LIST_MY_JOBS_PENDING_EMPLOYER,
  LIST_CURRENT_OFFER_JOBS,
  JOB_REJECT_OFFER,
  LIST_MY_JOBS_ONGOING_EMPLOYER,
  LIST_MY_JOBS_APPROVED_EMPLOYER,
  LIST_MY_JOBS_COMPLETED_EMPLOYER,
  SEARCH_MY_JOBS_EMPLOYER,
  DELETE_JOB_EMPLOYER,
  LIST_MY_JOBS_SUBMITTED_TALENT,
  LIST_MY_JOBS_CURRENT_OFFER_TALENT,
  LIST_MY_JOBS_PENDING_RESPONSE_TALENT,
  LIST_MY_JOBS_COMPLETED_TALENT,
  JOB_INTEREST_DETAIL,
  EMPLOYER_APPROVE_JOB_SUBMITTED,
  EMPLOYER_DECLINE_JOB_SUBMITTED,
  LIST_MY_JOBS_ONGOING_TALENT,
  JOB_INTEREST_TALENT_ACCEPT_OFFER,
  GET_SUBMITTED_JOB_EMPLOYER,
  SUBMIT_JOB_TALENT,
  CANCEL_JOB_TALENT,
  RATING_JOB_TALENT,
  DOWNLOAD_INVOICE,
  GET_JOBPICKED_LIST
} from '../../../utils/urls'

const actions = {
  getListPendingJobsEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_PENDING_EMPLOYER, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListPendingJobsEmployer', response.data['results'])
        context.commit('setTotalJobsEmployer', response.data['count'])
      }
    } catch (e) {
      context.commit('setListPendingJobsEmployer', [])
      context.commit('setTotalJobsEmployer', 0)
    }
  },
  getListCurrentOfferJobs: async (context) => {
    try {
      let response = await get(LIST_CURRENT_OFFER_JOBS)
      let status = response.status
      if (status === 200) {
        context.commit('setListCurrentOfferJobs', response.data['results'])
      }
    } catch (e) {
      context.commit('setListCurrentOfferJobs', [])
    }
  },
  talentRejectOffer: async (context, payload) => {
    let url = formatUrl(JOB_REJECT_OFFER, payload.params)
    await deleteMethod(url)
  },
  getListOngoingJobsEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_ONGOING_EMPLOYER, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListOngoingJobsEmployer', response.data['results'])
        context.commit('setTotalJobsEmployer', response.data['count'])
      }
    } catch (e) {
      context.commit('setListOngoingJobsEmployer', [])
      context.commit('setTotalJobsEmployer', 0)
    }
  },
  getListApprovedJobsEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_APPROVED_EMPLOYER, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListApprovedJobsEmployer', response.data['results'])
        context.commit('setTotalJobsEmployer', response.data['count'])
      }
    } catch (e) {
      context.commit('setListApprovedJobsEmployer', [])
      context.commit('setTotalJobsEmployer', 0)
    }
  },
  getListCompletedJobsEmployer: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_COMPLETED_EMPLOYER, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListCompletedJobsEmployer', response.data['results'])
        context.commit('setTotalJobsEmployer', response.data['count'])
      }
    } catch (e) {
      context.commit('setListCompletedJobsEmployer', [])
      context.commit('setTotalJobsEmployer', 0)
    }
  },
  getListSearchJobsEmployer: async (context, payload) => {
    try {
      let url = formatUrl(SEARCH_MY_JOBS_EMPLOYER, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListSearchJobsEmployer', response.data['results'])
        context.commit('setTotalJobsEmployer', response.data['count'])
      }
    } catch (e) {
      context.commit('setListSearchJobsEmployer', [])
      context.commit('setTotalJobsEmployer', 0)
    }
  },
  deleteJobEmployer: (context, payload) => {
    let url = formatUrl(DELETE_JOB_EMPLOYER, payload.params)
    return deleteMethod(url)
  },
  employerApproveJobSubmitted: (context, payload) => {
    let url = formatUrl(EMPLOYER_APPROVE_JOB_SUBMITTED, payload.params)
    return patch(url, payload.body)
  },
  employerDeclineJobSubmitted: (context, payload) => {
    let url = formatUrl(EMPLOYER_DECLINE_JOB_SUBMITTED, payload.params)
    return patch(url, payload.body)
  },
  getListOngoingJobsTalent: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_ONGOING_TALENT, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListOngoingJobsTalent', response.data['results'])
        context.commit('setTotalJobsTalent', response.data['count'])
      }
    } catch (e) {
      context.commit('setListOngoingJobsTalent', [])
      context.commit('setTotalJobsTalent', 0)
    }
  },
  getListSubmittedJobsTalent: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_SUBMITTED_TALENT, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListOngoingJobsTalent', response.data['results'])
        context.commit('setTotalJobsTalent', response.data['count'])
      }
    } catch (e) {
      context.commit('setListOngoingJobsTalent', [])
      context.commit('setTotalJobsTalent', 0)
    }
  },
  getListCurrentOfferJobsTalent: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_CURRENT_OFFER_TALENT, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListPendingJobsTalent', response.data['results'])
        context.commit('setTotalJobsTalent', response.data['count'])
      }
    } catch (e) {
      context.commit('setListPendingJobsTalent', [])
      context.commit('setTotalJobsTalent', 0)
    }
  },
  getListPendingResponseJobsTalent: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_PENDING_RESPONSE_TALENT, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListPendingJobsTalent', response.data['results'])
        context.commit('setTotalJobsTalent', response.data['count'])
      }
    } catch (e) {
      context.commit('setListPendingJobsTalent', [])
      context.commit('setTotalJobsTalent', 0)
    }
  },
  getListCompletedJobsTalent: async (context, payload) => {
    try {
      let url = formatUrl(LIST_MY_JOBS_COMPLETED_TALENT, payload.params)
      let response = await get(url, payload.queries)
      let status = response.status
      if (status === 200) {
        context.commit('setListCompletedJobsTalent', response.data['results'])
        context.commit('setTotalJobsTalent', response.data['count'])
      }
    } catch (e) {
      context.commit('setListCompletedJobsTalent', [])
      context.commit('setTotalJobsTalent', 0)
    }
  },
  talentUpdateInterest: async (context, payload) => {
    let url = formatUrl(JOB_INTEREST_DETAIL, payload.params)
    return patch(url, payload.body)
  },
  talentAcceptOffer: async (context, payload) => {
    let url = formatUrl(JOB_INTEREST_TALENT_ACCEPT_OFFER, payload.params)
    return patch(url, payload.body)
  },
  talentSubmitJob: async (context, payload) => {
    let url = formatUrl(SUBMIT_JOB_TALENT, payload.params)
    return post(url, payload.body)
  },
  talentCancelSubmitJob: async (context, payload) => {
    let url = formatUrl(CANCEL_JOB_TALENT, payload.params)
    return deleteMethod(url)
  },
  talentRatingJob: async (context, payload) => {
    return post(RATING_JOB_TALENT, payload.body)
  },
  getSubmittedJobInfo: async (context, payload) => {
    try {
      const url = formatUrl(GET_SUBMITTED_JOB_EMPLOYER, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setSubmittedJobInfo', response.data['results'])
      }
    } catch (e) {
      context.commit('setSubmittedJobInfo', [])
    }
  },
  getInvoiceList: async (context, payload) => {
    try {
      let response = await get(DOWNLOAD_INVOICE, payload.queries)
      return response.data
    } catch (e) {
      return e
    }
  },
  getJobPickedList: async (context, payload) => {
    try {
      const url = formatUrl(GET_JOBPICKED_LIST, payload)
      let response = await get(url)
      return response.data
    } catch (e) {
      return e
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/my-job/actions.js